import React from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useApi } from '~/hooks';
import Metric from '~/types/metrics';
import { MetricField } from '~/components/MetricField';
import { getIndividualMetrics } from '~/api/individual';

const label = (key: string): string => `resources.individuals.fields.${key}`;

const useStyles = makeStyles((theme) => ({
  bottomSpacing: {
    marginBottom: theme.spacing(2),
  },
}));

interface MetricsProps {
  id: string;
  emptyMessage?: boolean;
}

const Metrics = ({ id, emptyMessage }: MetricsProps) => {
  const [{ data: metrics }] = useApi<Metric[]>(() => getIndividualMetrics(id), [id]);

  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));

  if (!metrics && !emptyMessage) return null;
  return (
    <Grid container direction='column' spacing={2} className={classes.bottomSpacing}>
      {metrics && metrics.length > 0 ? (
        metrics.map((metric) => (
          <Grid item key={metric.key}>
            <MetricField name={metric.name} value={metric.value} target={metric.target} />
          </Grid>
        ))
      ) : (
        <Grid item>{t('noMetrics')}</Grid>
      )}
    </Grid>
  );
};

export default Metrics;
